import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ArticleService } from '../article.service';
import { Article } from '../article'

@Component({
  selector: 'app-article-detail',
  templateUrl: './article-detail.component.html',
  styleUrls: ['./article-detail.component.scss']
})

export class ArticleDetailComponent implements OnInit {
  model: Article
  params: Params
  constructor(private article: ArticleService, private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.params = this.activeRoute.snapshot.params
    this.article.getOne(this.params.Id).subscribe((Result: Article) => {
      console.log('-- get detail --')
      console.log(Result)
      this.model = Result
    })
  }

  submit() {
    console.log('-- submit article --')
    this.article.put(this.model).subscribe((Result: Article) => {
    })
  }
}
